import { render, staticRenderFns } from "./TransactionsTitle.vue?vue&type=template&id=085455da&scoped=true"
import script from "./TransactionsTitle.vue?vue&type=script&lang=js"
export * from "./TransactionsTitle.vue?vue&type=script&lang=js"
import style0 from "./TransactionsTitle.vue?vue&type=style&index=0&id=085455da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085455da",
  null
  
)

export default component.exports